var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStatesNoChartData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 61,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#979797",
    opacity: 0.6,
    cx: 19,
    cy: 59.75,
    rx: 19,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 10.904L26.716 1H4a3 3 0 00-3 3v40a3 3 0 003 3h30a3 3 0 003-3V10.904z",
    stroke: "#979797",
    strokeWidth: 2,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#979797",
    x: 8,
    y: 35,
    width: 4,
    height: 8,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#979797",
    x: 14,
    y: 31,
    width: 4,
    height: 12,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#979797",
    x: 20,
    y: 36,
    width: 4,
    height: 7,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#979797",
    x: 26,
    y: 33,
    width: 4,
    height: 10,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M27 0h.34L38 11.226v-.208H27z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.211 25.82c1.709-.957 3.353-1.435 4.933-1.435 1.579 0 3.115.478 4.608 1.436M27.056 15.051c-.812.479-1.594.718-2.344.718-.75 0-1.48-.24-2.19-.718M16.478 15.051c-.812.479-1.593.718-2.344.718-.75 0-1.48-.24-2.19-.718"
  })))));
}
export default SvgEmptyStatesNoChartData;